import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// API
import { useInView } from "react-intersection-observer";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

export const BrandStory = () => {
  const [ref, inView] = useInView({
    rootMargin: "-100px 0px",
  });

  return (
    <StyledDivFeatures3 ref={ref}>
      <StyledDivText>BRAND STORY</StyledDivText>
      <StyledDivOrangeLine className={inView ? "visible" : ""} />
    </StyledDivFeatures3>
  );
};

const StyledDivFeatures3 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${colors.logo_green};
  color: ${colors.white};
  ${getFontWeight("Heavy")};

  ${media.lessThan("small")`
    height: 80px;
  `};

  ${media.greaterThan("medium")`
    height: 100px;
  `};
`;

const StyledDivText = styled.div`
  ${media.lessThan("small")`
    font-size: 16px;
  `};

  ${media.greaterThan("medium")`
    font-size: 28px;
  `};
`;

const StyledDivOrangeLine = styled.div`
  position: absolute;
  border-bottom: solid 2px ${colors.logo_orange};

  ${media.lessThan("small")`
    bottom: 18px;
  `};

  ${media.greaterThan("medium")`
    bottom: 25px;
  `};

  width: 0;
  transition: all 300ms 0s ease;
  &.visible {
    ${media.lessThan("small")`
      width: 135px;
    `};

    ${media.greaterThan("medium")`
      width: 230px;
    `};
  }
`;
